import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['System'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    fusionGetIntegrations: builder.query({
      query: () => ({
        url: '/getSystemIntegrations_v2',
      }),
      transformResponse: (response) => response?.result || [],
      providesTags: ['System'],
    }),
    fusionAddIntegration: builder.mutation({
      query: (system) => ({
        url: '/addSystemIntegration_v2',
        method: 'POST',
        data: { system },
      }),
      invalidatesTags: ['System'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    fusionUpdateIntegration: builder.mutation({
      query: (system) => ({
        url: '/updateSystemIntegration_v2',
        method: 'POST',
        data: { system },
      }),
      invalidatesTags: ['System'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    fusionDeleteIntegration: builder.mutation({
      query: (system) => ({
        url: '/removeSystemIntegration_v2',
        method: 'POST',
        data: { system: system.id },
      }),
      invalidatesTags: ['System'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const {
  useFusionGetIntegrationsQuery,
  useFusionAddIntegrationMutation,
  useFusionUpdateIntegrationMutation,
  useFusionDeleteIntegrationMutation,
} = integrationsApi;
